enum SubPageName {
  ENROLLMENT_CHECKLIST,
  ACCESS_METHOD,
  EMPLOYER_CATEGORY,
  COMPANY_INFORMATION,
  COMPANY_ADDRESSES,
  HIRING_SITES,
  EVERIFY_USERS,
  REVIEW_AND_SUBMIT,
}

export default SubPageName;
